var exports = {
  "G": "StyledKeyboardMovingCardPlaceholder__1lVraw",
  "d": "isHidden__5VW15E",
};

module.exports = exports;
